
import VideoPlay from "../../../assets/duotone/VideoPlay.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VideoPlayIcon({ className, dataTestid = "VideoPlayIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VideoPlay data-testid={dataTestid} className={classes} {...rest} />
  );
}
